var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 11.3337L1.33301 12.167C1.33301 13.5477 2.4523 14.667 3.83301 14.667L12.1663 14.667C13.5471 14.667 14.6663 13.5477 14.6663 12.167L14.6663 11.3337M11.333 8.00033L7.99967 11.3337M7.99967 11.3337L4.66634 8.00033M7.99967 11.3337L7.99967 1.33366",
    stroke: "#eaa827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon2);
export default __webpack_public_path__ + "static/media/application-icon-2.81a67d0fdb725353f0d4c510f5c2eed3.svg";
export { ForwardRef as ReactComponent };